// extracted by css-extract-rspack-plugin
export default {"alias":"alias-eoMD8L","targetGood":"targetGood-JWulwG","targetBad":"targetBad-h8Yt3v","selected":"selected-reMWZE","errorIndicator":"errorIndicator-XwapeA"};